import useDictStore from '@/store/modules/dict'
import { getDicts } from '@/api/system/dict/data'
import cache from '@/plugins/cache'

/**
 * 获取字典数据
 */
export function useDict (...args) {
  const res = ref({})
  return (() => {
    args.forEach(async (dictType, index) => {
      res.value[dictType] = []
      const dicts = await useDictStore().getDict(dictType) || cache.session.getJSON(dictType)
      if (dicts) {
        res.value[dictType] = dicts
      } else {
        getDicts(dictType).then(resp => {
          res.value[dictType] = resp.data.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass }))
          useDictStore().setDict(dictType, res.value[dictType])
          cache.session.setJSON(dictType, res.value[dictType])
        })
      }
    })
    return toRefs(res.value)
  })()
}